import React, { useState, useEffect } from "react";
import {
  Box,
  Tabs,
  Tab,
  Typography,
  TextField,
  Autocomplete,
  Stack,
} from "@mui/material";
import BaseButton from "../../UI/BaseButton/BaseButton";
import { getProgramsForAccountingModule, postAccountingModuleAdjustment } from "../../../util/API/admin";
import PinPad from "../../PinPad/PinPad";
import CustomAlert from "../../UI/CustomAlert/CustomAlert";
import { commonRunQuery } from "../../../util/API/loans";

const postTypes = [
  { label: "ADD", value: "add" },
  { label: "REVERSE", value: "reverse" },
];

export default function AccountingModule() {
  const [tabIndex, setTabIndex] = useState(0);
  const [selectedProgram, setSelectedProgram] = useState();
  const [programs, setPrograms] = useState([]);
  const [rawPrograms, setRawPrograms] = useState([]);
  const [postAmount, setPostAmount] = useState("");
  const [postType, setPostType] = useState(postTypes[0]);
  const [comment, setComment] = useState("");
  const [showPinPad, setShowPinPad] = useState(false);
  const [alert, setAlert] = useState({
    showAlert: false, 
    severity: '',
    message: '',
    header: ''
  })
  const [accBalance, setAccBalance] = useState(null);

  let agent = JSON.parse(sessionStorage.getItem("user")).payload?.body;

  const getPrograms = async () => {
    const response = await getProgramsForAccountingModule();
    console.log(response)
    setRawPrograms(response?.payload);
    const programOptions = response?.payload?.map((program) => ({
      label: program.Cardprograms.programname + " [" + program.Cardprograms.programaccountno + "]",
      value: program.Cardprograms.programid,
      key: program.Cardprograms.programid
    }))
    setPrograms(programOptions);
  };

  useEffect(() => {
    getPrograms();
  }, [])

  useEffect(() => {
    console.log("selectedProgram======",selectedProgram);
    if(selectedProgram) {
      getBalance();
    }
  }, [selectedProgram])

  const handleClear = () => {
    // setSelectedProgram(programs[0]);
    setSelectedProgram(null);
    setPostAmount("");
    setPostType(postTypes[0]);
    setComment("");
    setAccBalance(null);
  };

  const handleSubmit = async(e, PIN) => {
    console.log(selectedProgram)
    const program = rawPrograms.find((program) => program?.Cardprograms?.programid === selectedProgram.value);
    console.log(program)
    const response = await postAccountingModuleAdjustment(
        program.Cardprograms.paycontrolaccountno,
        postAmount,
        agent['User'].id,
        program.Cardprograms.programaccountno,
        PIN,
        program.Cardprograms.defaultcurrencycode,
        comment,
        postType.value
    )

    if (response?.callStatus === "1") {
        setAlert({
            showAlert: true,
            severity: "success",
            message: "Transaction successfully committed. \n " + "Program: " +selectedProgram.label.split(" [")[0] + "\n balance: " + response?.currency + " " + (
              parseFloat(response?.balance) > 0
                ? -Math.abs(parseFloat(response?.balance))
                : Math.abs(parseFloat(response?.balance))
            ).toFixed(2) ?? 0,
            // message: "Transaction successfully committed. \n " + "Program: " +selectedProgram.label.split(" [")[0] + "\n balance: " + response?.currency + " " + response?.balance ?? 0,
            header: "Success"
        })
        handleClear();
    } else {
        setAlert({
            showAlert: true,
            severity: "error",
            message: response.payload.msg,
            header: "Error"
        })
    }
  };

  const handleConfirm = (event, pin) => {
    let PIN = pin.join('');
    handleSubmit(event, PIN);
    setShowPinPad(false);
  };

  // const getBalance = async() => {
  //   const program = rawPrograms.find((program) => program?.Cardprograms?.programid === selectedProgram.value);
  //   console.log("SelectedProgram==========",selectedProgram);
  //   console.log("program==========",program.Cardprograms.programaccountno);
  //   try {
  //     const respone = await commonRunQuery(1, program.Cardprograms.programaccountno);
  //     console.log("getBalance==========", respone);
  //     if(respone?.data?.header?.callStatus == "1" && parseInt(respone?.data?.header?.reccount) > 0) {
  //       let balanceStr = respone?.data?.body?.record?.acctbalance?.balance;
  //       let balanceNum = parseFloat(balanceStr);
  //       console.log("balanceNum==========", balanceNum);
  //       let flippedBalance = balanceNum * -1;

  //       setAccBalance(Number((balanceNum * -1).toFixed(2)));
  //     }
  //   } catch (err) {
  //     console.log("getBalance_err==========",err);

  //   }
  // }

  const getBalance = async () => {
    try {
      const program = rawPrograms.find(
        (p) => p?.Cardprograms?.programid === selectedProgram.value
      );
  
      console.log("SelectedProgram==========", selectedProgram);
      console.log("program==========", program.Cardprograms.programaccountno);
  
      const response = await commonRunQuery(1, program.Cardprograms.programaccountno);
      console.log("getBalance==========", response);
  
      if (
        response?.data?.header?.callStatus === "1" &&
        parseInt(response?.data?.header?.reccount) > 0
      ) {
        let record = response?.data?.body?.record;
  
        // ✅ Normalize to array
        const records = Array.isArray(record) ? record : [record];
  
        // ✅ Transform all balances
        const formattedBalances = records.map((r) => {
          const acct = r?.acctbalance;
          if (!acct) return null;
  
          let balanceNum = parseFloat(acct.balance);
          let flippedBalance = balanceNum * -1;
  
          return {
            currCode: acct.currCode,
            balance: Number(flippedBalance.toFixed(2)),
          };
        }).filter(Boolean);
  
        console.log("formattedBalances==========", formattedBalances);
        setAccBalance(formattedBalances);
      } else {
        setAccBalance([{
          "currCode": "USD",
          "balance": 0
        }]);
      }
    } catch (err) {
      console.error("getBalance_err==========", err);
      setAccBalance([]);
    }
  };

  return (
    <Box
        sx={{ 
            display: "flex", 
            justifyContent: "center", 
            alignItems: "center", 
            backgroundColor: "#f5f5f5", 
            padding: "16px" 
        }}
    >
      <Box
        sx={{ 
            backgroundColor: "#ffffff", 
            borderRadius: "8px", 
            boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)", 
            width: "600px", 
            padding: "24px", 
            textAlign: "center", 
            display: "flex", 
            flexDirection: "column", 
            alignItems: "center" 
        }}
      >
        <Typography 
            variant="h6" 
            sx={{ 
                marginBottom: "16px", 
                color: "#333333", 
                fontWeight: "bold" 
            }}
        >
            Accounting Module
        </Typography>

        <Tabs
          value={tabIndex}
          onChange={(e, newValue) => setTabIndex(newValue)}
          variant="fullWidth"
          TabIndicatorProps={{ style: { display: "none" } }}
          sx={{
            mb: 3,
            "& .MuiTab-root": {
              textTransform: "capitalize",
              color: "#BCBCBC",
              fontFamily: "Inter",
              fontSize: 15,
              fontStyle: "normal",
              fontWeight: 400,
              lineHeight: "30px",
              backgroundColor: "#f8f8f8",
              "&.Mui-selected": {
                backgroundColor: "white",
                // color: "#5523D2",
                color: "#00365A",
                borderRadius: "6px 6px 0 0 !important",
                textAlign: "center",
                fontSize: 15,
                fontStyle: "normal",
                fontWeight: 600,
                lineHeight: "30px",
                borderBottom: 0,
                borderBottomColor: "#FAC800",
                borderBottomWidth: 4,
              },
            },
          }}
        >
          <Tab label="Program Adjustment" />
          {/* <Tab label="Account Adjustment" />
          <Tab label="Chart of Accounts" />
          <Tab label="Search Accounts" /> */}
        </Tabs>

        {tabIndex === 0 && (
          <Stack spacing={2}>
            <Autocomplete
              options={programs}
              value={selectedProgram || null}
              onChange={(e, newValue) => setSelectedProgram(newValue)}
              renderInput={(params) => (
                <TextField {...params} label="Program" fullWidth />
              )}
            />
            <TextField
              label="Post Amount"
              type="number"
              fullWidth
              value={postAmount}
              onChange={(e) => setPostAmount(e.target.value)}
            />
            <Autocomplete
              options={postTypes}
              value={postType}
              onChange={(e, newValue) => setPostType(newValue)}
              renderInput={(params) => (
                <TextField {...params} label="Post Type" fullWidth />
              )}
            />
            <TextField
              label="Comment"
              fullWidth
              value={comment}
              onChange={(e) => setComment(e.target.value)}
            />

            <Stack direction="row" justifyContent="center" spacing={2} mt={2}>
              <BaseButton buttonText={"Clear"} onClick={handleClear} />
              <BaseButton
                buttonText={"Post Adjustment"}
                onClick={() => setShowPinPad(true)}
              />
            </Stack>

            <Typography
              variant="body2"
              align="center"
              sx={{ mt: 3, fontStyle: "italic", color: "#555" }}
            >
              Select Program to Post Adjustments (Wire Deposits)
            </Typography>

            {Array.isArray(accBalance) && accBalance.length > 0 && (
              <Box sx={{ mt: 3 }}>
                <Typography
                  variant="body2"
                  align="center"
                  sx={{ fontWeight: "bold", color: "#555" }}
                >
                  Current Balances:
                </Typography>
                {accBalance.map((item, index) => (
                  <Typography
                    key={index}
                    variant="body2"
                    align="center"
                    sx={{ fontWeight: "bold", color: "#333" }}
                  >
                    {item.currCode}: {item.balance.toFixed(2)}
                  </Typography>
                ))}
              </Box>
            )}
          </Stack>
        )}
      </Box>
      <CustomAlert 
        severity={alert.severity} 
        show={alert.showAlert} 
        header={alert.header} 
        message={alert.message} 
        onClick={(prev) => setAlert({...prev, showAlert: false})} 
        autoclose={alert.severity === "error" ? false : true} 
      />
      {showPinPad && 
        <PinPad 
          show={showPinPad} 
          handleConfirm={handleConfirm} 
          onClick={() => setShowPinPad(false)} 
        />
      }
    </Box>
  );
}

